import type {
  AccountingOAuthStatusRequest,
  AccountingOAuthStatusResult,
} from "@src/domain/dto/accountingOAuth";
import type { IAccountingOAuthRepository } from "@src/domain/repositories/accountingOAuth";

export class GetAccountingOAuthStatusUseCase {
  private readonly repository: IAccountingOAuthRepository;

  constructor(repository: IAccountingOAuthRepository) {
    this.repository = repository;
  }

  execute(params: AccountingOAuthStatusRequest): Promise<AccountingOAuthStatusResult> {
    return this.repository.getStatus(params);
  }
}
